var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTips),expression:"showTips"}],staticClass:"mc-tips"},[_c('p',{on:{"click":_vm.toLink}},[_c('font',[_vm._v("前往"),_c('span',[_vm._v("河北日报")]),_vm._v(" 客户端才可参与活动哦~")])],1),_c('span',{staticClass:"close-mc",on:{"click":_vm.closeTips}},[_vm._v("关闭提醒")])])
}
var staticRenderFns = []

export { render, staticRenderFns }